export default "__VITE_ASSET__68f65414__"